import React from "react";
import {
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardHeader,
  CardContent,
} from "@material-ui/core";
import { Check } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useRouter } from "../common/Router";
import { pushCustomEvent } from "../../utils/customEventHelper";

const RegistrationBenefits: React.FC = () => {
  const { t } = useTranslation();
  const { setLoc } = useRouter();

  const benefits = Object.values<string>(
    t("registrationBenefits.list", {
      returnObjects: true,
    }),
  );

  return (
    <Card style={{ marginTop: 20 }}>
      <CardHeader
        data-testid="registrationTitle"
        titleTypographyProps={{
          align: "center",
          gutterBottom: false,
          paragraph: false,
          variant: "h2",
        }}
        title={t("registrationBenefits.title")}
      />
      <CardContent>
        <Button
          style={{ marginBottom: 15 }}
          variant="contained"
          size="large"
          color="primary"
          fullWidth
          onClick={(): void => {
            pushCustomEvent("registrationLink");
            setLoc("signup");
            window.location.hash = "#signup";
            window.scrollTo(0, 0);
          }}
          data-testid="registrationButton"
        >
          {t("registrationBenefits.registerAction")}
        </Button>

        <List data-testid="benefits" disablePadding>
          {benefits.map((value, i) => {
            return (
              <ListItem key={i} dense disableGutters alignItems="flex-start">
                <ListItemIcon
                  style={{ minWidth: 28, transform: "translate(0px, -5px)" }}
                >
                  <Check color="secondary" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      data-testid={`benefitsItem${i}`}
                    >
                      {value}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

export default RegistrationBenefits;
